<form class="modal-form" [formGroup]="form" class="mb-4">
  <app-input
    [control]="codeControl"
    [isRequired]="true"
    [placeholder]="'features.validateCoupon.searchCoupon' | transloco"
    [icon]="'mdi cursor-pointer ' + (hasDetails ? 'mdi-close' : 'mdi-magnify')"
    (iconClick)="onClick()"
    (keyup.enter)="onClick()"
  >
  </app-input>
</form>

<ng-container *ngIf="!loading && !hasDetails">
  <div class="search-block">
    <img alt="" class="search-block__img" src="assets/images/load-img.svg" />
    <div class="search-block__text">{{ "features.validateCoupon.search_text" | transloco }}</div>
  </div>
</ng-container>
